import { useState } from 'react'

type Setter<T> = (value: T) => void

function useLocalStorage<T>(key: string, initialValue: T): [T, Setter<T>] {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key)

      if (item) {
        return JSON.parse(item)
      }

      window.localStorage.setItem(key, JSON.stringify(initialValue))

      return initialValue
    } catch (error) {
      console.error(error) // eslint-disable-line no-console
      return initialValue
    }
  })

  const setValue = (value: T): void => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)
      window.localStorage.setItem(key, JSON.stringify(valueToStore))
    } catch (error) {
      console.error(error) // eslint-disable-line no-console
    }
  }

  return [storedValue, setValue]
}

export { useLocalStorage }
